<template>
    <div class="v-dropdown" :style="{ top: y + 'px', left: x + 'px' }">
        <div class="v-dropdown__item" v-for="(item, index) in items" :key="index" @click.stop="handleItemClick(item)"
            :class="{ 'v-dropdown__item--red': item.red }">
            <span>{{ item.label }}</span>
        </div>
    </div>
    <div class="v-dropdown-overlay" @click="$emit('close')"></div>
</template>

<script>
export default {
    name: 'VDropdown',
    props: {
        items: {
            type: Array,
            default: () => []
        },
        x: {
            type: Number,
            default: 0
        },
        y: {
            type: Number,
            default: 0
        }
    },
    methods: {
        handleItemClick(item) {
            item.action();
            this.$emit('close');
        }
    },
    mounted() {
        // Prevent scrolling when menu is open? Maybe not needed for now.
    }
}
</script>

<style lang="scss">
.v-dropdown {
    position: fixed;
    z-index: 1000;
    background-color: var(--color-bg);
    border: 1px solid var(--color-border);
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    padding: 5px;
    min-width: 150px;
    display: flex;
    flex-direction: column;
    gap: 2px;

    &__item {
        padding: 8px 15px;
        cursor: pointer;
        border-radius: 6px;
        transition: background-color 0.2s;
        font-size: 0.9rem;
        color: var(--color-text);

        &:hover {
            background-color: var(--color-bg-hover);
        }
    }

    &__item--red {
        color: var(--color-red);
    }
}

.v-dropdown-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 999;
    background: transparent;
}
</style>
